import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';
import Header from './components/Header';
import Banner from './components/Banner';
import About from './components/About';
import Team from './components/Team';
import Home from './components/Home';
import Podcasts from './components/Podcasts';
import PhotoGallery from './components/Phototheque';
import VideoGallery from './components/Videotheque';
import Contact from './components/Contact';
import Footer from './components/Footer';
import './assets/styles/App.css';

const App = () => {
  return (
    <LanguageProvider>
      <Router>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/podcasts" element={<Podcasts />} />
          <Route path="/phototheques" element={<PhotoGallery />} />
          <Route path="/videotheques" element={<VideoGallery />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        <Footer />
      </Router>
    </LanguageProvider>
  );
};



export default App;